const CRUD = {
    overview: {
        ordersOverview: "/overview_order",
        usersOverview: "/overview_users",
        transactionOverview: "/overview_transactions",
    },
    admin: {
        list: "/admins",
        add: "/admins",
        update: "/admins/update",
    },
    supportAgent: "/support_agents",
    activities: "/activities",
    cryptoAssets: "/cryto_asset",
    cryptoRates: "/crypto_rate",
    cryptoRanges: "/crypto_range",
    paymentWalletAddress: "/wallet_address",
    giftcardVendor: "/giftcard_vendor",
    systemVariables: "/sys_variables",
    appContent:{
        featuredPosts: "/featured_posts",
        appPosts: "/app_posts",
    },
    cruise: {
        import: "/cruise/import",
        batch: "/cruise/batch",
        list: "/cruise",
        root: "/cruise",
        history: "/cruise/history",
        telementry: "/cruise/telementry",
        overview: "/cruise/overview",
    },
    campaign: {
        create: "/campaign",
        eligibleUsers: "/campaign/affected_users",
        root: "/campaign",
        history: "/campaign/history",
        telementry: "/campaign/telementry",
    },

    compliance: {
        overview:"/compliance/overview",
        health:"/compliance/health",
        history:"/compliance/history",
        queue:"/compliance/queue",
        review:"/compliance/review",
        addressApprove:"/compliance/address",
        addressReject:"/compliance/address",
    },

    user: { 
        list: "/users",
        update: "/user/update",
        search: "/users/find",
        findUserById: "/user/get_user",
        referralList: "/user/referrals",
        transactions: "/user/transactions",
        invitelList: "/user/invites",
        details: "/user/details",
        kycDetails: "/user/kyc_details",
        kycDetailsNG: "/user/kyc_details_ng",
        submtReview: "/user/kyc_review",
        submtReviewNG: "/user/kyc_ng_review",
        security_changes: "/user/update_setting",
        suspend_user: "/user/suspend_user",
        wallet: "/users/wallet",
        auditBalance:"/user/balance_audit", 
        updateUserProfile:"/user/update_profile", 
       
    },
    order: {
        list: "/orders",
        search: "/orders/find",
        details: "/orders/details",
        confirmPayment: "/orders/confirm_payment",
        completeOrder: "/orders/complete",
        doHold: "/orders/hold",
        giftcardList: "/giftcard_orders",
        giftcardSearch: "/giftcard_orders/find",
        giftcardOrderDetails: "/giftcard_orders/details",
        giftcardOrderComplete: "/giftcard_orders/complete",
        giftcardOrderDispute: "/giftcard_order/dispute",
        giftcardOrderReject: "/giftcard_orders/reject",
    },
    rewards: {
        referralRanking: "/referral_ranking",
        monthlyBonus: "/monthly_bonus",
    },
    blockchain: {
        transactions: "/blockchain/transactions",
        transactionsFind: "/blockchain/transactions/find",
        transactionDetails: "/blockchain/transaction/details",
        walletAddresses: "/blockchain/wallet_addresses",
        walletAddressesFind: "/blockchain/wallet_addresses/find",
        quidaxAccounts: "/blockchain/quidax_accounts",
        quidaxAccountsFind: "/blockchain/quidax_accounts/find",
        instantSwaps: "/blockchain/instant_swaps",
        instantSwapsFind: "/blockchain/instant_swaps/find",
        retrySwapAction: "/blockchain/transaction/action",
    },
    database: {
        transactions: "/transactions",
        searchTransactions: "/transactions/find",
        searchBills: "/bills_payment/find",
        bills: "/bills_payment",
        paystackTransfer: "/paystack_transfers",
        searchPaystackTransfer: "/paystack_transfers/find",
        paystackCollections: "/paystack_collections",
    },
    collections:{
        bankAccount: {
            list: "/virtual_accounts",
            saveBank: "/virtual_account",
            updateBank: "/virtual_account/update",
            bankList: "/banks",
            resolveBankAccount: "/bank/resolve_account",
            saveOtherBanks: "/bank/save_other_bank",
        },
        providusSettlement: "/providus_bank_settlement",
        searchProvidusSettlement: "/providus_bank_settlement/find",
        incomingPayment: "/incoming_payment",
        searchIncomingPayment: "/incoming_payment/find",
        withdrawals: {
            list: "/withdrawals",
            find: "/withdrawals/find",
            confirm: "/withdrawals/confirm",
            reject: "/withdrawals/reject",
        },
    }
}

export default CRUD;